import { Link } from 'react-router';
import { useSubscription } from './api';
import { formatNumber } from '../../lib/format';

/** Compact shipments-used meter for the sidebar. Server-computed; nothing here is authoritative. */
export function UsageMeter() {
  const { data } = useSubscription();
  if (!data) return null;
  const { used, limit, pausedShipments } = data.usage;
  const ratio = limit > 0 ? Math.min(1, used / limit) : 1;
  const tone = ratio >= 1 ? 'bg-status-exception' : ratio >= 0.8 ? 'bg-signal-500' : 'bg-brand-600';

  return (
    <Link
      to="/billing"
      className="mx-1 block rounded-lg border border-ink-200 bg-white px-3 py-2.5 hover:border-ink-300"
    >
      <div className="flex items-baseline justify-between text-xs">
        <span className="font-semibold text-ink-800">{data.plan.name} plan</span>
        <span className="text-ink-500 tabular-nums">
          {formatNumber(used)} / {formatNumber(limit)}
        </span>
      </div>
      <div
        className="mt-2 h-1.5 overflow-hidden rounded-full bg-ink-100"
        role="progressbar"
        aria-label="Shipments tracked this billing period"
        aria-valuemin={0}
        aria-valuemax={limit}
        aria-valuenow={used}
      >
        <div className={`h-full rounded-full ${tone}`} style={{ width: `${ratio * 100}%` }} />
      </div>
      {pausedShipments > 0 ? (
        <p className="mt-1.5 text-xs font-medium text-status-exception">
          {pausedShipments} not tracked · Upgrade
        </p>
      ) : ratio >= 0.8 ? (
        <p className="mt-1.5 text-xs font-medium text-amber-700">Almost at your limit · Upgrade</p>
      ) : (
        <p className="mt-1.5 text-xs text-ink-500">Shipments this period</p>
      )}
    </Link>
  );
}
